import { render } from "./lesson-gallery.vue?vue&type=template&id=2e77b3f6&ts=true"
import script from "./lesson-gallery.ts?vue&type=script&lang=ts&external"
export * from "./lesson-gallery.ts?vue&type=script&lang=ts&external"

import "./lesson-gallery.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__